import { PlusCircleOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import type { InsuranceInput } from '../../../graphql/generated/graphql.ts';
import type { Insurance } from '../Insurances.tsx';
import { CREATE_INSURANCE_MUTATION } from './CreateInsuranceModal.gql';
import { InsuranceForm } from './InsuranceForm';

export const CreateInsuranceModal: React.FC<{
  open: boolean;
  onClose: () => void;
  allInsurances: Insurance[];
}> = ({ open, onClose, allInsurances }) => {
  const [createInsuranceMutation, { loading }] = useMutation(CREATE_INSURANCE_MUTATION);
  const [form] = useForm<InsuranceInput>();
  const { message } = App.useApp();

  const create = async (values: InsuranceInput) => {
    try {
      await createInsuranceMutation({
        variables: {
          input: values,
        },
      });

      message.success('Krankenkasse wurde erstellt');
      closeAndReset();
    } catch (e) {
      message.error(`Krankenkasse konnte nicht erstellt werden: ${e}`);
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      width={768}
      title="Neue Krankenkasse erstellen"
      okText="Erstellen"
      okButtonProps={{ icon: <PlusCircleOutlined /> }}
      open={open}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
    >
      <InsuranceForm
        codeValidator={code => allInsurances.length === 0 || !allInsurances.some(i => i.code === code)}
        form={form}
        onFinish={create}
      />
    </Modal>
  );
};
